import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyOtp } from '../../services/UserService';
import { useCookies } from 'react-cookie';

export default function VerifyOtp() {
  const [otp, setOtp] = useState('');
  const [errMsg, setErrMsg] = useState('')
  const [successMsg, setSuccessMsg] = useState('')
  const [cookies, setCookies, removeCookie] = useCookies();
  const navigate = useNavigate()
  const location = useLocation()

  const handleOtp =()=>{
    setErrMsg("")
    setSuccessMsg("")
    const data = {
      userId: location.state.userId,
      otp: otp
    }

    verifyOtp(data)
    .then((res)=>{
      if(res.status == 200){
        setSuccessMsg("Registeration Successful")
        console.log(res.data.token)
        setCookies("accessToken", res.data.token)
        setCookies("userId", res.data.userId)
        navigate('/')        
      }
    })
    .catch((err)=>{
      if(err.response.status == 403){
        setErrMsg("Wrong Otp")
      }else{
        setErrMsg("Service Unavailable")
        console.log(err)
      }
    })
  }
  

  return (
    <Dialog open={true} onClose={false}>
    <DialogTitle>OTP Verification</DialogTitle>
    <DialogContent>
    <DialogContentText>
        To change to password, please enter your original password
    </DialogContentText>
    {errMsg != '' && <div className='alert alert-danger'>{errMsg}</div>}
    {successMsg != '' && <div className='alert alert-success'>{successMsg}</div>}
    <div style={{marginTop: '5%'}}>
        <span style={{display: 'block', marginLeft: '30%'}}>
        <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
            />
        </span>
    </div>
    </DialogContent>
    <DialogActions>
    <Button onClick={handleOtp}>Verify</Button>
    </DialogActions>
</Dialog>

  );
}